export default __webpack_public_path__ + "assets/6879249d84d6b4eb4c79c12b11c4e06d.png";